var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M11.4249 17.35C12.282 17.35 12.9767 16.6202 12.9767 15.72C12.9767 14.8197 12.282 14.09 11.4249 14.09C10.5678 14.09 9.87305 14.8197 9.87305 15.72C9.87305 16.6202 10.5678 17.35 11.4249 17.35Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M17.4037 9.53V8.28C17.4037 5.58 16.7849 2 11.4248 2C6.06478 2 5.44594 5.58 5.44594 8.28V9.53C2.78019 9.88 1.9043 11.3 1.9043 14.79V16.65C1.9043 20.75 3.09437 22 6.99779 22H15.8519C19.7553 22 20.9454 20.75 20.9454 16.65V14.79C20.9454 11.3 20.0695 9.88 17.4037 9.53ZM11.4248 18.74C9.83491 18.74 8.54964 17.38 8.54964 15.72C8.54964 14.05 9.84443 12.7 11.4248 12.7C13.0053 12.7 14.3001 14.06 14.3001 15.72C14.3001 17.39 13.0148 18.74 11.4248 18.74ZM6.99779 9.44C6.92163 9.44 6.85498 9.44 6.77882 9.44V8.28C6.77882 5.35 7.56902 3.4 11.4248 3.4C15.2807 3.4 16.0709 5.35 16.0709 8.28V9.45C15.9947 9.45 15.9281 9.45 15.8519 9.45H6.99779V9.44Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }